.root {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4px;
  pointer-events: none;
  width: 100%;
  border: none;
  appearance: none;
  background: transparent;
}

.root::-webkit-progress-bar {
  background: transparent;
}

.root::-webkit-progress-value {
  border-bottom-left-radius: var(--radius-md);
  background-color: var(--progress-color, var(--snack-bar-progress-color));
  transition: width 0.1s linear;
}

.root::-moz-progress-bar {
  border-bottom-left-radius: var(--radius-md);
  background-color: var(--progress-color, var(--snack-bar-progress-color));
}
